export const READING_PANE_CONTAINER_ID = 'ReadingPaneContainerId';
